import React from 'react';

function Toggle({ checked, onChange, label, hint, disabled = false, accent = '#1C3D2E', solid = false }) {
  // solid=true — фон всегда брендовый (для action-тумблеров типа "В архив")
  return (
    <label style={{
      display: 'inline-flex', alignItems: 'center', gap: 10,
      cursor: disabled ? 'not-allowed' : 'pointer', userSelect: 'none',
      opacity: disabled ? 0.6 : 1,
    }}>
      {/* Фирменный переключатель NovaFlo: трек со срезами, бегунок — половина,
          отделённая диагональю (стили .nf-switch в styles.css). */}
      <span
        className={`nf-switch${checked ? ' on' : ''}${solid ? ' solid' : ''}`}
        style={{ '--sw-on': accent }}
      >
        <span className="nf-switch-knob" />
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => !disabled && onChange(e.target.checked)}
          style={{ position: 'absolute', inset: 0, opacity: 0, cursor: 'inherit', margin: 0 }}
        />
      </span>
      {label && (
        <span style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={{ fontSize: 14, fontWeight: 600, color: '#1C3D2E' }}>{label}</span>
          {hint && <span style={{ fontSize: 12, color: '#5E6561' }}>{hint}</span>}
        </span>
      )}
    </label>
  );
}

export default Toggle;
